// utils/sessionStorageUtils.ts
import {SummaryFilterState} from '../../redux/slice/summaryFilterSlice';

const SUMMARY_FILTER_KEY = 'summaryFilter';

export const saveSummaryFilterToSession = (filterState: SummaryFilterState): void => {
    try {
        sessionStorage.setItem(SUMMARY_FILTER_KEY, JSON.stringify(filterState));
    } catch (error) {
        console.error('Failed to save filter to SessionStorage:', error);
    }
};

export const loadSummaryFilterFromSession = (): SummaryFilterState | null => {
    try {
        const savedFilter = sessionStorage.getItem(SUMMARY_FILTER_KEY);
        return savedFilter ? JSON.parse(savedFilter) : null;
    } catch (error) {
        console.error('Failed to load filter from SessionStorage:', error);
        return null;
    }
};
